
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import ThresholdSlider from '~/components/Device/Threshold/ThresholdSlider.vue';
import { Device, ObjectDetectionSensibiliy } from '~/interfaces/device.interface';
import apiService from '~/services/api.service';
import { NotificationsModule } from '~common/store/modules/notifications';

@Component({
    components: { ThresholdSlider },
})
export default class SensitivityConfig extends Vue {
    @Prop() device!: Device;

    thresholds: Record<string, ObjectDetectionSensibiliy> = {};

    get humanThreshold() {
        return this.thresholds.object_detection_sensitivity.human;
    }

    set humanThreshold(value) {
        this.thresholds.object_detection_sensitivity.human = value;
    }

    get animalThreshold() {
        return this.thresholds.object_detection_sensitivity.animal;
    }

    set animalThreshold(value) {
        this.thresholds.object_detection_sensitivity.animal = value;
    }

    get vehicleThreshold() {
        return this.thresholds.object_detection_sensitivity.vehicle;
    }

    set vehicleThreshold(value) {
        this.thresholds.object_detection_sensitivity.vehicle = value;
    }

    @Watch('device')
    async fetchThresholds() {
        try {
            const response = (await apiService.getvpndeviceconfigs({
                device_id: this.device.id,
            })).data.body;
            if (response?.id && !response.object_detection_sensitivity) {
                response.object_detection_sensitivity = {
                    human: 3,
                    animal: 3,
                    vehicle: 3,
                };
            }
            this.thresholds = response;
        } catch (e) {
            NotificationsModule.pushNotification({
                type: 'error',
                title: 'Error while getting config for this device',
                duration: 5000,
            });
        }
    }

    async saveNewThresholds() {
        try {
            const body = {
                device_id: this.device.id,
                config: {
                    object_detection_sensitivity: this.thresholds.object_detection_sensitivity,
                },
            };
            await apiService.setvpndeviceconfigs(body);
            NotificationsModule.pushNotification({
                type: 'success',
                title: 'Thresholds saved successfully',
                duration: 5000,
            });
        } catch (e) {
            NotificationsModule.pushNotification({
                type: 'error',
                title: 'Error while saving new thresholds',
                duration: 5000,
            });
        }
    }

    mounted() {
        this.fetchThresholds();
    }
}
